import React, { useEffect, useState } from 'react';
interface NavItem {
  id: string;
  label: string;
}
const SECTIONS: NavItem[] = [{
  id: 'intro',
  label: 'Intro'
}, {
  id: 'work',
  label: 'Experience'
}, {
  id: 'skills',
  label: 'Capabilities'
}, {
  id: 'earlier',
  label: 'Earlier'
}, {
  id: 'education',
  label: 'Education'
}];
/**
 * Fixed right-rail section indicator (desktop). Each node highlights when its
 * section is active; the connector fills up to the active node. Clicking a node
 * smooth-scrolls to it. Hidden on mobile and in print.
 */
export function SectionNav() {
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const els = SECTIONS.map(s => document.getElementById(s.id));
    const onScroll = () => {
      const mid = window.innerHeight * 0.4;
      let idx = 0;
      els.forEach((el, i) => {
        if (el && el.getBoundingClientRect().top <= mid) idx = i;
      });
      setActiveIndex(idx);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <nav aria-label="Sections" className="no-print fixed right-6 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-end gap-4 lg:flex xl:right-8" data-id="element-310" data-mp="2s26ph0bi50cq">
      {SECTIONS.map((s, i) => {
      const isActive = i === activeIndex;
      const isPast = i < activeIndex;
      return <button key={s.id} type="button" onClick={() => go(s.id)} aria-current={isActive ? 'true' : undefined} className="group/nav flex items-center gap-3 focus:outline-none" data-id="element-311" data-mp="2e2f5miyb0pqt" data-mpi={i}>
            <span className={`whitespace-nowrap font-mono text-[9px] uppercase tracking-[0.2em] transition-all duration-300 ${isActive ? 'translate-x-0 text-[var(--accent)] opacity-100' : 'translate-x-1 text-stone-400 opacity-0 group-hover/nav:translate-x-0 group-hover/nav:opacity-100'}`} data-id="element-312" data-mp="12qnyo4cc025o">
              {s.label}
            </span>
            <span className={`block h-[10px] w-[10px] shrink-0 rounded-full border transition-all duration-300 ${isActive ? 'scale-110 border-[var(--accent)] bg-[var(--accent)]' : isPast ? 'border-[var(--accent)]/50 bg-[var(--accent)]/40' : 'border-white/40 bg-transparent group-hover/nav:border-white'}`} data-id="element-313" data-mp="z4syi2riab8m" />
          </button>;
    })}
    </nav>;
}